module.exports = __webpack_public_path__ + "static/media/trash-teal.cabbc3dc.svg";